import tealiumProcessor from '../tealium/tealium';
import { constants } from '../constants/constants';

/**
 * This method holds the logic to trigger the event if there is no
 * unresolveData and push it to the queue if there is unresolvedData
 * @param  {Object} data
 */
const processDataCaptureEvent = ( data ) => {
  if( data?.unresolvedData && data?.unresolvedData?.length > 0 ){

    datacapture.dataCaptureQueue.push( data );

    const triggerResolution = setInterval( function(){
      datacapture.triggerEvents();
      /**
       * Every 100 milliseconds try to resolve client side data,
       * once all data are resolved exit the timer
       *  */
      if( datacapture.dataCaptureQueue === 0 ){
        clearInterval( triggerResolution );
      }
    }, 100 );
  }
  else {
    datacapture.triggerEvent( data );
  }

}
/**
 * This method invokes processDataCaptureEvent to trigger the event
 * depending on the eventType passed as param
 * @param  {Object} data
 * @param  {String} eventType
 * @param  {Function} handleInteractionEvents
 * @param  {Object} additionalEventAttributes
 */
export const processEvents = ( data, eventType, handleInteractionEvents, additionalEventAttributes = {} )=>{

  if( data.dataCapture ){
    switch ( eventType ){
      case constants.DATACAPTURE_EVENT_TYPE.viewport :
        datacapture.processDataCaptureEvent( { ...data.dataCapture, handleInteractionEvents } )
        break;
      case constants.DATACAPTURE_EVENT_TYPE.click:
        datacapture.processDataCaptureEvent( { ...data.dataCapture, handleInteractionEvents, additionalEventAttributes } )
        break;
      case constants.DATACAPTURE_EVENT_TYPE.response:
        datacapture.processDataCaptureEvent( { ...data.dataCapture, handleInteractionEvents, additionalEventAttributes } )
        break;
    }
  }
}
/**
 * This method takes the eventData loops through the integrations,
 * fetches the integration processor and triggers the event
 * @param  {Object} data
 */
const triggerEvent = ( data ) => {
  const { category, dataLayer, ...rest } = data;
  dataLayer && Object.keys( dataLayer ).forEach( ( key ) => {
    let eventProcessor = datacapture.fetchEventProcessor( key );
    if( eventProcessor ){
      eventProcessor.triggerEvent( { category, dataLayer: dataLayer[key], ...rest } );
    }
  } )
}


/**
 * This method takes the integrationName and sends the corresponding processor
 * @param  {String} key
 */
const fetchEventProcessor = ( key ) => {
  let eventProcessor = null;
  if( key.toLowerCase() === 'tealium' ){
    eventProcessor = tealiumProcessor;
  }
  return eventProcessor;
}


/**
 * This method loops through the array , resolves the client data, if all data are resolved then
 * trigger the event if there is data yet to be resolved then it adds the event back to the queue
 */
const triggerEvents = ( ) => {
  let temporaryQueue = [];
  let eventData = datacapture.dataCaptureQueue.shift();
  while ( eventData ){
    let builtData = datacapture.resolveClientDataLayer( eventData );
    if( builtData?.unresolvedData?.length === 0 ){
      datacapture.triggerEvent( builtData, builtData.handleInteractionEvents );
    }
    else {
      temporaryQueue.push( builtData );
    }
    eventData = datacapture.dataCaptureQueue.shift();
  }
  datacapture.dataCaptureQueue = temporaryQueue.slice();
}

/**
 * this method loops through the unresolved data array resolves
 * the data and removes that entry from the array
 *
 * @param  {Object} data
 */
const resolveClientDataLayer = ( data ) => {
  let localUnresolvedData = [];
  let { category: originalCategory, dataLayer:originalDataLayer, unresolvedData:originalUnresolvedData, ...rest } = data;
  let clonedData = JSON.parse( JSON.stringify( { originalCategory, originalDataLayer, originalUnresolvedData } ) ) // cloning this data as this is a props and immutable
  let { originalCategory:category, originalDataLayer:dataLayer, originalUnresolvedData:unresolvedData } = clonedData;

  unresolvedData && unresolvedData.forEach( ( elementData ) => {
    let dataValue = null;
    if( elementData?.service && elementData?.service?.toLowerCase() === 'client' ){
      const { serviceDataPath, integrationsforChannel } = elementData;
      switch ( serviceDataPath ){
        case 'GTI':
          dataValue = global?.globalPageData?.profile?.GTI;
          break;
        case 'CookieDeviceId':
          dataValue = localStorage.getItem( 'deviceID' );
          break;
        case 'KnownGTI':
          dataValue = datacapture.resolveKnownGTI();
          break;
        default:
          dataValue = datacapture.resolveAdditionalAttributes( elementData?.serviceDataPath, rest.additionalEventAttributes );
          break;
      }

      if( ( dataValue || dataValue === 0 ) && typeof dataValue === 'number' ){
        dataValue = dataValue.toString();
      }

      if( dataValue === '' || dataValue ){
        if( dataValue && typeof dataValue === 'string' ){
          dataValue = dataValue.toLowerCase();
        }

        integrationsforChannel.forEach( ( integration ) => {
          dataLayer[integration.integrationName][integration.dataKey] = dataValue;
        } );
      }
      else {
        localUnresolvedData.push( elementData );
      }
    }
  } );

  return { category, dataLayer, unresolvedData : localUnresolvedData, ...rest };
}

/**
 * This method resolves the known (Signed in User) GTI value, if the firstname is present in the globalPageData
 * then the corresponding GTI is returned as knownGTI if firstName is empty returns empty else returns null
 */
const resolveKnownGTI = () =>{
  let knownGTI = null;
  if( global?.globalPageData?.profile?.GTI ){
    if( global?.globalPageData?.profile?.firstName && global?.globalPageData?.profile?.firstName.trim() !== '' ){
      knownGTI = global?.globalPageData?.profile?.GTI
    }
    else {
      knownGTI = '';
    }
  }

  return knownGTI;
}

/**
 * @method resolveAdditionalAttributes
 * @summary This method takes the serviceDataPath and additionalEventAttributes retrieves
 * the value matching the serviceDataPath from the additionalEventAttributes and returns the match
 * @param  {String} serviceDataPath
 * @param  {Object} additionalEventAttributes
 * @returns the matching value
 */
const resolveAdditionalAttributes = ( serviceDataPath, additionalEventAttributes ) =>{
  return additionalEventAttributes ? additionalEventAttributes[serviceDataPath] : '';
}

/**
 * @method triggerDatacaptureEvent
 * @summary This method triggers datacapture events
 * @param { Object } datacaptureEvent dxl response
 */
export const triggerDatacaptureEvent = ( datacaptureEvent ) => {
  if( datacaptureEvent ){
    datacapture.processEvents( { dataCapture : datacaptureEvent }, datacaptureEvent?.clientEvent?.toLowerCase() );
  }
}

const datacapture = {
  dataCaptureQueue: [],
  processDataCaptureEvent,
  triggerEvent,
  triggerEvents,
  fetchEventProcessor,
  resolveClientDataLayer,
  resolveKnownGTI,
  processEvents,
  resolveAdditionalAttributes,
  triggerDatacaptureEvent
}

export default datacapture;